import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BrandLaravelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-laravel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 17l8 5l7 -4v-8l-4 -2.5l4 -2.5l4 2.5v4l-11 6.5l-4 -2.5v-7.5l-4 -2.5z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 18v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 15.5l7 -4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 7.5v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 11.5l4 2.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 13v-7.5l-4 -2.5l-4 2.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 8l4 -2.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 10l4 -2.5"
    }, null), _createTextVNode(" ")]);
  }
};